import { render, staticRenderFns } from "./Intrastat.vue?vue&type=template&id=f7d8b66e"
import script from "./Intrastat.vue?vue&type=script&lang=js"
export * from "./Intrastat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports